import React, { useState } from 'react';
import styled from '@emotion/styled';

const SecurityContainer = styled.div`
  background-color: #E3FCEF;
  border: 1px solid #57D9A3;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
  position: relative;
`;

const SecurityHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: ${props => props.isExpanded ? '16px' : '0'};
  cursor: pointer;
`;

const SecurityIcon = styled.div`
  color: #006644;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SecurityTitle = styled.h3`
  font-size: 16px;
  color: #006644;
  margin: 0;
  flex-grow: 1;
`;

const ToggleButton = styled.button`
  background: none;
  border: none;
  color: #006644;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
  transform: ${props => props.isExpanded ? 'rotate(180deg)' : 'rotate(0)'};
`;

const SecurityContent = styled.div`
  display: ${props => props.isExpanded ? 'block' : 'none'};
  color: #006644;
  font-size: 14px;
  line-height: 1.5;
`;

const SecurityList = styled.ul`
  margin: 12px 0;
  padding-left: 20px;
`;

const SecurityListItem = styled.li`
  margin-bottom: 8px;
`;

const SecurityInfo = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <SecurityContainer>
      <SecurityHeader onClick={toggleExpanded} isExpanded={isExpanded}>
        <SecurityIcon>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
          </svg>
        </SecurityIcon>
        <SecurityTitle>Your Data is Secure</SecurityTitle>
        <ToggleButton isExpanded={isExpanded}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </ToggleButton>
      </SecurityHeader>
      
      <SecurityContent isExpanded={isExpanded}>
        <p>
          This tool operates entirely in your browser - no data is stored on our servers. 
          We've implemented several security measures to protect your information:
        </p>
        
        <SecurityList>
          <SecurityListItem>
            <strong>Client-Side Processing:</strong> All data processing happens locally on your device.
          </SecurityListItem>
          <SecurityListItem>
            <strong>No Server Storage:</strong> Your content remains private and is automatically cleared when you close the browser tab.
          </SecurityListItem>
          <SecurityListItem>
            <strong>Input Validation:</strong> All inputs are validated and sanitized to prevent security issues.
          </SecurityListItem>
          <SecurityListItem>
            <strong>Content Security Policy:</strong> We restrict which resources can be loaded to prevent cross-site scripting attacks.
          </SecurityListItem>
          <SecurityListItem>
            <strong>Secure Headers:</strong> We use security headers to protect against common web vulnerabilities.
          </SecurityListItem>
        </SecurityList>
        
        <p>
          Downloaded preview files are saved only to your local device and are not transmitted to any server.
        </p>
      </SecurityContent>
    </SecurityContainer>
  );
};

export default SecurityInfo; 